module.exports = __webpack_public_path__ + "img/concrete_slab.5cfa0780.jpg";